import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-add-question-button',
  standalone: true,
  templateUrl: './add-question-button.component.html',
  styleUrl: './add-question-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddQuestionButtonComponent {
  // Signal inputs
  readonly disabled = input(false);

  // Signal outputs
  readonly add = output<void>();

  handleAdd(): void {
    if (this.disabled()) {
      return;
    }
    this.add.emit();
  }
}

